import React, { useContext } from "react";
import * as tasks from "../extended/May2026Tasks";
import { MaturaReviewContext } from "../../components/MaturaExamRunner/MaturaReviewContext";
import MaturaOriginalSourceLinks from "../../components/MaturaOriginalSourceLinks";
import MaturaPdfPreview from "../../components/MaturaPdfPreview";

export const sheet = { id: "cke-r-2026-maj", title: "Matura rozszerzona — maj 2026",
  subtitle: "Formuła 2023 · 13 punktowanych części · 50 punktów", sourceLabel: "CKE · maj 2026 · rozszerzenie",
  taskCount: 13, maxPoints: 50, sessionType: "main" };
export const classification = tasks.classification;
export function generateTaskVariant(number, variant = "random", options = {}) {
  number = String(number);
  if (number.startsWith("12.") && !options.single) {
    const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
    const linkedTasks = ["12.1", "12.2"].map(n => generateTaskVariant(n, variant, { ...options, seed, single: true }));
    return { ...linkedTasks.find(row => row.meta.taskNo === number), linkedTasks };
  }
  const task = tasks.generateTask(number, { ...options, variant });
  return { index: tasks.taskNumbers.indexOf(number), task: { ...task, displayBaseNumber: Number(number.split(".")[0]) },
    meta: { ...classification.find(row => row.taskNo === number), quizTypeKey: task.type, quizKind: "open", assessmentMode: "self" } };
}
export function generatePagedTasks(variant = "original", options = {}) {
  const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
  return tasks.taskNumbers.map(number => generateTaskVariant(number, variant, { ...options, single: true, seed: `${seed}:${number.startsWith("12.") ? "flowerbed" : number}` }));
}
export function generateTasks(variant, options) { return generatePagedTasks(variant, options).map(row => row.task); }
export const getVariantCounts = tasks.getVariantCounts;
function OriginalLink({ task }) {
  const review = useContext(MaturaReviewContext);
  if (review.interactive && !review.reviewAllowed) return null;
  return <MaturaPdfPreview url={tasks.pdfUrl("arkusz", task.taskNumber)} title={`Arkusz CKE · maj 2026 · zadanie ${task.taskNumber}`} label="Zadanie w oryginalnym PDF · maj 2026"/>;
}
export function renderTask(task) { return <>{tasks.renderTask(task)}<MaturaOriginalSourceLinks task={task}/><OriginalLink task={task}/></>; }
export const renderInput = tasks.renderInput;
export const checkAnswer = tasks.checkAnswer;
export const renderAnswer = tasks.renderAnswer;
export const renderExplanation = tasks.renderExplanation;
export const renderUserAnswer = tasks.renderUserAnswer;
export function getInteractionSupport() { return { renderInput: true, checkAnswer: true, renderUserAnswer: true }; }
